export default __webpack_public_path__ + "static/media/warrior_no_data_group1.ec3b383b.png";